import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { ModeEditorToggleTitle } from "../styled";

interface ModeEditorToggleProps {
  advancedMode: boolean;
  toggleMode: VoidFunction;
  fontSize?: string;
  maxWidth?: string;
}

export const ModeEditorToggle: FC<ModeEditorToggleProps> = ({ advancedMode, toggleMode, fontSize, maxWidth }) => {
  const { t } = useTranslation("dialogs");

  return (
    <ModeEditorToggleTitle fontSize={fontSize || "1rem"} maxWidth={maxWidth || "100%"} onClick={toggleMode}>
      {advancedMode ? t("featuresMultiEdit.switchToStandardMode") : t("featuresMultiEdit.switchToProMode")}
    </ModeEditorToggleTitle>
  );
};
